// MF-560 — Local development only: which school the local front end acts as. The backend (with
// DEV_TENANT_OVERRIDE=true and NODE_ENV != production) reads it from the X-Dev-Tenant-Domain header
// instead of the page's domain, so no hosts-file entries or local certificates are needed.
// import.meta.env.DEV is false in every build (beta / production), so none of this ships active.

const KEY = 'maestro.devTenantDomain'

export const isDevTenantEnabled = import.meta.env.DEV && import.meta.env.VITE_DEV_TENANT_SWITCHER === 'true'

export const getDevTenant = () => {
  if (!isDevTenantEnabled) return ''
  try {
    return localStorage.getItem(KEY) || import.meta.env.VITE_DEV_TENANT_DOMAIN || ''
  } catch {
    return import.meta.env.VITE_DEV_TENANT_DOMAIN || ''
  }
}

/** Switch school: a session belongs to one school, so log out and go to the login page. */
export const switchDevTenant = (domain) => {
  try {
    localStorage.setItem(KEY, domain)
    localStorage.removeItem('accessToken')
    localStorage.removeItem('persist:root')
  } catch {
    /* storage blocked: the default from .env stays in use */
  }
  window.location.assign('/login')
}
